import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from '../views/login/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/salesBillManage',
    name: 'salesBillManage',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/salesBillManage/index.vue')
  },
  {
    path: '/menuNav',
    name: 'menuNav',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/menuNav/index.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
